// extracted by mini-css-extract-plugin
export var option = "_4i-1";
export var optionActive = "_4i-2";
export var pill = "_4i-0";